import {
  CustomerTypeOption,
  SurveyAssetPaths,
  SurveyServiceOption,
} from './survey.models';

export const CUSTOMER_TYPE_OPTIONS: CustomerTypeOption[] = [
  { label: 'Huesped', value: 'guest' },
  { label: 'Visitante', value: 'visitor' },
  { label: 'Socio', value: 'member' },
];

export const SURVEY_ASSET_PATHS: SurveyAssetPaths = {
  mascot: 'assets/mascot-service-selection.png',
  customerMascot: 'assets/mascot-customer-data.png',
  mobileMascot: 'assets/mascot-mobile.png',
  serviceMascot: 'assets/mascot-service-selection.png',
  logo: 'assets/ribera-logo.png',
  topLeftLeaf: 'assets/leaves/top-left-corner.png',
  topRightLeaf: 'assets/leaves/top-right-corner.png',
  bottomLeftLeaf: 'assets/leaves/bottom-left-corner.png',
  bottomRightLeaf: 'assets/leaves/center-right.png',
  customerBackground: 'assets/miscellaneous/background-mascot-left-alt.png',
  mobileBackground: 'assets/miscellaneous/background-mascot-mobile.png',
  topCornerEllipse: 'assets/miscellaneous/elipse-top-corner.png',
  mascotShadow: 'assets/miscellaneous/mascot-shadow.png',
  topRightCorner: 'assets/leaves/top-right-corner.png',
  centerRight: 'assets/leaves/center-right.png',
  bottomLeftCenter: 'assets/leaves/bottom-left-center.png',
  bottomLeftCorner: 'assets/leaves/bottom-left-corner.png',
  heartIcon: 'assets/icons/solar_heart-bold.svg',
  securityIcon: 'assets/icons/security-time.svg',
};

export const SURVEY_SERVICE_OPTIONS: SurveyServiceOption[] = [
  {
    id: 'accommodation',
    title: 'Alojamiento',
    description: 'Habitaciones e instalaciones',
    icon: 'pi pi-home',
    imageSrc: 'assets/services/accommodation.png',
    accent: 'green',
  },
  {
    id: 'restaurant',
    title: 'Restaurante',
    description: 'Gastronomia y atencion',
    icon: 'pi pi-shop',
    imageSrc: 'assets/services/restaurant.png',
    accent: 'yellow',
  },
  {
    id: 'services-entertainment',
    title: 'Servicios y Entretenimiento',
    description: 'Actividades, diversión y experiencias del resort',
    icon: 'pi pi-star',
    imageSrc: 'assets/services/activity-service.png',
    accent: 'green',
  },
];
